import React from "react";

export default function Footer({
  className,
  slogan,
  copyright,
}: {
  className?: string;
  slogan?: React.ReactChild;
  copyright?: React.ReactChild;
}) {
  return (
    <div className={className}>
      <span className="slogan">
        {!!slogan && <>{slogan}</>}
        {!slogan && <>Medical Data. Secured.</>}
      </span>
      <p>
        {!!copyright && <>{copyright}</>}
        {!copyright && (
          <>
            Copyright &copy; 2020-{new Date().getFullYear()}{" "}
            <a href="https://www.jnpmedi.com" target="_blank" rel="noopener noreferrer">
              JNPMEDI
            </a>{" "}
            all rights reserved.
          </>
        )}
      </p>
    </div>
  );
}
